<template>
  <div class="m-edition-section-content-subject">
    <p class="margin-top-zero">
      <span>Aún no tienes contenidos activos para este curso.</span>
    </p>
    <p>
      <router-link
        class="text-color-academy-primary"
        to="/"
      >
        Volver a listado de Mis Cursos.
      </router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetContentEmpty'
}
</script>
